import copyIcon from "../../../assets/icons/copy.svg";
import verifyIcon from "../../../assets/icons/verify.svg";
import { useEffect, useRef, useState } from "react";

export const CopyButton = ({ text }: { text: string }) => {
  const [hasCopied, setHasCopied] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | undefined>();

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(text);
    setHasCopied(true);
    timerRef.current = setTimeout(() => setHasCopied(false), 1000);
  };

  return (
    <div>
      {hasCopied ? (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={verifyIcon}
            style={{ cursor: "auto" }}
            alt="verify"
            title="Copied"
          />
          <span
            style={{ marginLeft: "5px", fontSize: "12px", marginBottom: "6px" }}
          >
            Copied
          </span>
        </div>
      ) : (
        <img
          src={copyIcon}
          alt="arrow"
          onClick={copyToClipboard}
          title="Copy to clipboard"
        />
      )}
    </div>
  );
};
